<template>
    <v-menu ref="menu"
            v-model="menupicker"
            :close-on-content-click="false"
            max-width="300"
            :content-class="menuClass"
            offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-text-field :value="hijridate" 
                          :label="label"
                          :rules="rules"
                          :dense="dense"
                          :class="styles"
                          :outlined="outlined"
                          :filled="filled"
                          :disabled="disabled"
                          v-bind="attrs"
                          clearable
                          :hide-details="hideDetails == null ? false : hideDetails"
                          readonly
                          @click:clear="handleClear"
                          v-on="on" />
        </template>
        <v-hijri-date-picker ref="picker"
                             v-model="hijridate"
                             locale="ar"
                             width="100%"
                             :type="typeFormat"
                             :max="maxHijri"
                             :min="minHijri"
                             @input="handleInput"
                             @click:year="getYear($event)" />
    </v-menu>
</template>

<script>
    import moment from 'moment-hijri'
    import VHijriDatePicker from 'vuetify-umalqura'

    export default {

        components: {
            VHijriDatePicker
        },

        props: ['label', 'rules', 'hijri', 'value', 'typeDate', 'min', 'max', 'dense', 'outlined', 'styles', 'disabled', 'hideDetails', 'filled'],

        //value is the date in gregorian format
        //hijri is the date in hijri format
        //min is the min value in gregorian
        //max is the max value in gregorian   this.value != null ? moment(this.value, 'YYYY-MM-DD').format('iYYYY-iMM-iDD') : null

        data() {
            return {
                menupicker: false,

                nameRules: [
                    v => !!v || this.validate == true
                ],
                hijridate: this.convertToHijriDate(this.value)
            }
        },

        computed: {
            isRTL() {
                // Check if current locale is Arabic (RTL)
                return this.$i18n && this.$i18n.locale === 'ar'
            },
            menuClass() {
                return this.isRTL ? 'hijri-picker-menu-rtl' : 'hijri-picker-menu-ltr'
            },
            maxHijri() {
                moment.locale('en-us')
                return this.getResultDate(this.max)
            },

            minHijri() {
                moment.locale('en-us')
                return this.getResultDate(this.min)
            },
            typeFormat() {
                moment.locale('en-us')
                if (this.typeDate == 'month') {
                    return 'month'
                } else if (this.typeDate == 'year') {
                    return 'year'
                } else {
                    return 'date'
                }
            }
        },

        watch: {
            value(value) {
               
                const isValid = this.isValidHijriDate(value)
                if (!isValid) {
                    if (typeof value === 'string') {
                        this.hijridate = this.convertToHijriDate(value)
                        this.$emit('update:hijri', this.hijridate)
                    } else {
                        console.warn('Received non-string value in watcher:', value)
                    }
                    this.$emit('update:hijri', this.hijridate)
                } else {
                    this.$emit('update:hijri', this.hijridate)

                }
            },
            menupicker(val) {
                if (this.typeDate == 'year') {
                    val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
                }
            },
        },

        methods: {
            getResultDate(date) {
                moment.locale('en-us')
                if (date) {
                    if (this.typeDate == 'month') {
                        
                        return moment(new Date(date)).format('iYYYY-iMM')
                    } else if (this.typeDate == 'year') {
                        const yearDt = moment(date).year()
                        return moment((Number(yearDt) + 1).toString(), 'YYYY').format('iYYYY')
                    } else {
                        return moment(new Date(date)).format('iYYYY-iMM-iDD')
                    }
                } else {
                    return null
                }

            },
            handleInput() {
                this.menupicker = false
                moment.locale('en-us')
                if (this.typeDate == 'month') {
                    this.$emit('update:hijri', this.hijridate)
                    this.$emit('input', this.hijridate)
                } else if (this.typeDate == 'year') {
                    this.$emit('update:hijri', this.hijridate)
                    this.$emit('input', this.hijridate)
                } else {
                    const gregorianDate1 = this.convertToGregorianDate(this.hijridate)
                    this.$emit('update:hijri', this.hijridate)
                    this.$emit('input', gregorianDate1)
                }

            },

            handleClear() {
                this.$emit('input', null)
            },
            isValidHijriDate(hijriDate) {
                const [year, month] = hijriDate.split('-').map(Number)
                const gregorianDate = moment(`${year}-${month}-01`, 'iYYYY-iMM-DD')

                return gregorianDate.isValid()
            },
            convertToHijriDate(date) {
                if (!date) return null
                moment.locale('en-us')
                if (this.typeDate == 'date') {
                    return date != null ? moment(new Date(date)).format('iYYYY-iMM-iDD') : null

                } else if (this.typeDate == 'month') {
                    return date != null ? moment(new Date(date)).format('iYYYY-iMM') : null
                } else if (this.typeDate == 'year') {
                    return date != null ? moment(new Date(date)).format('iYYYY') : null
                }
            },
            convertToGregorianDate(date) {
                if (!date) return null
                moment.locale('en-us')
                if (this.typeDate == 'date') {
                    return moment(date, 'iYYYY-iMM-iDD').format('YYYY-MM-DD')

                } else if (this.typeDate == 'month') {
                    return moment(date, 'iYYYY-iMM').format('YYYY-MM')
                } else if (this.typeDate == 'year') {
                    return moment(date, 'iYYYY').format('YYYY')
                }
            },
            getYear(yearDate) {

                if (this.typeDate == 'year') {
                    this.hijridate = yearDate.toString()

                    this.$emit('update:hijri', this.hijridate)
                    this.$emit('input', this.convertToGregorianDate(this.hijridate))
                    this.menupicker = false
                }


            }
        }
    }
</script>

<style>
/* Remove scoped to apply to menu content */
.hijri-picker-menu-rtl .v-picker {
    transform-origin: top right !important;
}

.hijri-picker-menu-ltr .v-picker {
    transform-origin: top left !important;
}

.hijri-picker-menu-rtl.v-menu__content {
    transform-origin: top right !important;
}

.hijri-picker-menu-ltr.v-menu__content {
    transform-origin: top left !important;
}
</style>
